import funcButtonHoverStyled from "src/utils/helper/funcButtonHoverStyled";
import { Span, StyledButton } from "./style";

const LoadingBaseBTN = ({ children, ...props }) => (
  <StyledButton {...props} onMouseMove={funcButtonHoverStyled}>
    <Span>{children}</Span>
  </StyledButton>
);

export default LoadingBaseBTN;
